<template>
  <div>
    <v-layout class="systock-breadcrump text-uppercase" align-center>
      <v-flex xs5>
        <v-breadcrumbs>
          <v-breadcrumbs-item>
            <h4 title="Planejamento de Distribuição de Produtos">
              Planejamento de Distribuição de Produtos
            </h4>
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-flex>
    </v-layout>

    <v-card flat>
      <v-tabs centered>
        <v-tab class="tab-personalizado">
          <v-icon left>mdi-truck-delivery</v-icon>Separação de
          Mercadorias
        </v-tab>

        <v-tab class="tab-personalizado">
          <v-icon left>mdi-clipboard-list</v-icon>Lista de Pedidos
        </v-tab>

        <v-tab class="tab-personalizado">
          <v-icon left>mdi-playlist-remove</v-icon>Produtos Silenciados
        </v-tab>

        <v-tab class="tab-personalizado">
          <v-icon left>mdi-tune</v-icon>
          <v-icon left x-small class="ml-n4 mb-n3" style="background: white">mdi-settings</v-icon>
          Cobertura por Produto
        </v-tab>

        <v-tab class="tab-personalizado">
          <v-icon left>mdi-chart-bell-curve</v-icon>
          <v-icon left x-small class="ml-n4 mt-n3">mdi-settings</v-icon>
          Cobertura X Curvas
        </v-tab>

        <v-tab class="tab-personalizado" v-if="showMapeamentoDistribuicao">
          <v-icon left>mdi-tune</v-icon>
          Distribuição Por Categoria
        </v-tab>

        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <SeparacaoMercadorias
                @atualizarPedido="atualizar = $event"
                :atualizarCarrinho="atualizarCar"
                :configuracaoDRP="configuracaoDRP"
                @update:produtos-silenciados="() => atualizar_produtos_silenciados_count++"
              />
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <ListaPedidos
                @atualizarCarrinho="atualizarCar = $event"
                :atualizarPedido="atualizar"
              />
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <ListaFiltro :atualizar_produtos_silenciados_count="atualizar_produtos_silenciados_count" />
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <CoberturaPorProduto />
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <CoberturaPorCurvaPopularidade />
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item class="ma-0" v-if="showMapeamentoDistribuicao">
          <v-card flat>
            <v-card-text class="pa-0">
              <DistribuicaoPorFamilia />
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>
<script>
import SeparacaoMercadorias from "./separacaoDeMercadorias/Index.vue";
import ListaPedidos from "./listaDePedidos/Index.vue";
import ListaFiltro from "./filtroDeProdutos/Index.vue";
import CoberturaPorCurvaPopularidade from './tempoCoberturaPorCurvaPopularidade/Index.vue'
import CoberturaPorProduto from "./coberturaPorProduto/Index.vue"
import DistribuicaoPorFamilia from "./mapeamentoDeDistribuicaoDeFilialPorFamilia/Index.vue"
import DrpAPI from "../../api/drp.js"

export default {
  name: "drpmenu",
  components: {
    SeparacaoMercadorias,
    ListaPedidos,
    ListaFiltro,
    CoberturaPorCurvaPopularidade,
    CoberturaPorProduto,
    DistribuicaoPorFamilia
  },
  data() {
    return {
      atualizar: 0,
      atualizarCar: 0,
      atualizar_produtos_silenciados_count: 0,
      configuracaoDRP: {
        drp_multipla_selecao_filiais: "S",
        exportacao_protheus_drp: "N",
        exportacao_winthor_drp: 'N',
        tipo_drp: 1,
        drp_mapeamento_distribuicao_por_categpria: 'N',
        exportacao_automatiza: false,
        drp_exportacao_nativa_winthor: false,
        integracao_exportacao_casa_tudo_sacolao: 'N',
        exportacao_drp_padre_cicero: false,
      },
    };
  },
  computed: {
    showMapeamentoDistribuicao() {
      return ['S', 's'].includes(this.configuracaoDRP.drp_mapeamento_distribuicao_por_categpria)
    }
  },
  created() {
    this.Helpers.verificarToken();
    this.buscarConfiguracaoDRP()
  },
  methods: {
    buscarConfiguracaoDRP() {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        DrpAPI.getConfiguracaoDRP(headers)
          .then((response) => {
            const { token, configuracaoDRP } = response.data;

            localStorage.setItem("token", token);
            localStorage.setItem("configuracao_drp", JSON.stringify(configuracaoDRP));

            this.configuracaoDRP = configuracaoDRP;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
  }
};
</script>

<style>
/*
 **   ALTURA DINAMICA EM DIFERENTES TAMANHOS DE TELAS
 */
@media (max-width: 1500px) {
  .tab-personalizado {
    font-size: 12.5px;
    letter-spacing: 0px;
    color: red;
  }
}

@media (max-height: 10000px) {
  .table-drp-resposivo .v-data-table__wrapper {
    height: 550px !important;
  }
}

@media (max-height: 1040px) {
  .table-drp-resposivo .v-data-table__wrapper {
    height: 550px !important;
  }
}

@media (max-height: 940px) {
  .table-drp-resposivo .v-data-table__wrapper {
    height: 520px !important;
  }
}

@media (max-height: 900px) {
  .table-drp-resposivo .v-data-table__wrapper {
    height: 470px !important;
  }
}

@media (max-height: 850px) {
  .table-drp-resposivo .v-data-table__wrapper {
    height: 420px !important;
  }
}

@media (max-height: 800px) {
  .table-drp-resposivo .v-data-table__wrapper {
    height: 370px !important;
  }
}

@media (max-height: 750px) {
  .table-drp-resposivo .v-data-table__wrapper {
    height: 320px !important;
  }
}

@media (max-height: 700px) {
  .table-drp-resposivo .v-data-table__wrapper {
    height: 270px !important;
  }
}

.table-drp-resposivo .v-data-table__wrapper {
  overflow: auto !important;
}
</style>
